import { api, method } from '../api/apiClient';

export const addInventoryItems = async (payload) => {
    try {
        return await api(method.POST, '/inventory', payload);
    } catch (error) {
        console.error(`Error for add inventory items ${error}`);
        throw error;
    }
};

export const fetch = async ({
    hotelId,
    skip = 0,
    limit = 10,
    sortKey = '',
    sortOrder = '',
    filterKey = '',
    filterValue = ''
}) => {
    try {
        const query = `skip=${skip}&limit=${limit}&sortKey=${sortKey}&sortOrder=${sortOrder}&filterKey=${filterKey}&filterValue=${filterValue}`;
        return await api(method.GET, `/inventory/${hotelId}?${query}`);
    } catch (error) {
        console.error(`Error while fetching inventory list ${error}`);
        throw error;
    }
};

export const updateInventoryItems = async (payload) => {
    try {
        return await api(method.PUT, '/inventory', payload);
    } catch (error) {
        console.error(`Error for update inventory items ${error}`);
        throw error;
    }
};

export const removeInventoryItems = async (payload) => {
    try {
        return await api(method.DELETE, '/inventory', payload);
    } catch (error) {
        console.error(`Error for removing inventory item ${error}`);
        throw error;
    }
};

export const fetchRecipes = async ({
    hotelId,
    page = 0,
    search = ''
}) => {
    try {
        const query = `search=${search}&page=${page}`;
        return await api(method.GET, `/inventory/recipe/${hotelId}?${query}`);
    } catch (error) {
        console.error(`Error while fetching recipes list ${error}`);
        throw error;
    }
};

export const fetchMatchingInventories = async ({ hotelId }) => {
    try {
        return await api(method.GET, `/inventory/options/${hotelId}`);
    } catch (error) {
        console.error(`Error while fetching inventories options list ${error}`);
        throw error;
    }
};

export const manageRecipes = async (payload) => {
    try {
        return await api(method.POST, '/inventory/recipe', payload);
    } catch (error) {
        console.error(`Error for managing recipe items ${error}`);
        throw error;
    }
};

export const removeRecipe = async (menuId) => {
    try {
        return await api(method.DELETE, `/inventory/recipe/${menuId}`);
    } catch (error) {
        console.error(`Error for removing recipe ${error}`);
        throw error;
    }
};
